export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/product/addProductBenifit',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['productbyid']       
    })
